'use client'

import Link from 'next/link'
import { SignOut } from '@/utils/saas/auth-helpers/server'
import { handleRequest } from '@/utils/saas/auth-helpers/client'
import { usePathname, useRouter } from 'next/navigation'
import { getRedirectMethod } from '@/utils/saas/auth-helpers/settings'
import { useUser } from '@auth0/nextjs-auth0'

export default function Navlinks() {
  const tmpRouter = useRouter()
  const router = getRedirectMethod() === 'client' ? tmpRouter : null
  const pathname = usePathname() ?? '/' // @@BUG: Hack because path must be defined.
  const { user, isLoading } = useUser()

  return (
    <div className="relative flex flex-row justify-between py-4 align-center md:py-6">
      <div className="flex items-center flex-1">
        <nav className="ml-6 space-x-2 lg:block">
          {user && (
            <></>
            /* @@TODO */
            /*
            <Link href="/saas/account">
              Account
            </Link>
            */
          )}
        </nav>
      </div>
      <div className="flex justify-end space-x-8">
        {user ? (
          <form
            onSubmit={(e) => {
              // NOTE: Intentionally not awaited.
              void handleRequest(e, SignOut, router)
            }}
          >
            <input type="hidden" name="pathName" value={pathname} />
            <button type="submit">Sign out</button>
          </form>
        ) : (
          // @@TODO
          <Link href="/saas/signin">Sign In</Link>
        )}
      </div>
    </div>
  )
}
